import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Highlighter from 'react-highlight-words';
import './ResultsTable.css';


const mainColumns = [
  {
    dataField: 'lema',
    text: 'Lema',
    sort: true,
  },
  {
    dataField: 'freq',
    text: 'Dažnis',
    sort: true,
  },
  {
    dataField: 'arbitral',
    text: 'Arbitralioji',
    sort: true,
  },
  {
    dataField: 'main_word',
    text: 'Pagr. žodis',
    sort: true,
  },
  {
    dataField: 'main_word_pos',
    text: 'Pagr. žodžio kalbos dalis',
    sort: true,
  },
  {
    dataField: 'sr',
    text: 'Sintaksinis ryšys',
    sort: true,
  },
  {
    dataField: 'word_order_changeable',
    text: 'Keičiasi žodžių tvarka',
    sort: true,
  },
  {
    dataField: 'grammar_variants',
    text: 'Gramatiniai variantai',
    sort: true,
  },
];

const formsColumns = [
  {
    dataField: 'form',
    text: 'Forma',
    sort: true,
  },
  {
    dataField: 'form_freq',
    text: 'Formos dažnis',
    sort: true,
  },
  {
    dataField: 'insertion',
    text: 'Įsiterpimo galimybė',
    sort: true,
  },
  {
    dataField: 'grammar',
    text: 'Morfologinė informacija',
    sort: false,
  },
];

const defaultFormsSorted = [
  {
    dataField: 'form_freq',
    order: 'desc',
  }
];

const defaultLemasSorted = [
  {
    dataField: 'freq',
    order: 'desc',
  }
];

const getWordsToHighlight = (text) => {
  const regex = /(\[\[)(.*)(\]\])/g;
  const matched = text.match(regex);

  return (matched && matched.map(el => removeBrackets(el))) || [];
};

const removeBrackets = text => text.replace(/ \[\[|\[\[ | ]]|]] |\[\[|]]/g, '');

class ResultsTable extends React.Component {
  formsTable() {
    return {
      renderer: row => (
        <div>
          <h3>Vartojimo pavyzdžiai</h3>
          <ul>
            {row.examples.map((kw, index) =>
              <li key={index}>
                <Highlighter
                  highlightClassName="mwe-highlight"
                  searchWords={getWordsToHighlight(kw)}
                  autoEscape={true}
                  textToHighlight={removeBrackets(kw)}
                />
              </li>
            )}
          </ul>
          <h3>Kaitybinės formos</h3>
          <BootstrapTable
            bootstrap4
            defaultSorted={defaultFormsSorted}
            keyField='form'
            data={row.forms}
            columns={formsColumns}
          />
        </div>
      ),
      expanded: this.props.expanded,
      onExpand: this.props.handleOnExpand,
      showExpandColumn: true
    };
  }

  onTableChange = (type, newState) => {
    if (newState.data.length > 0) {
      if (type === 'pagination') {
        this.props.handleTableChange(newState.page);
      } else if (type === 'sort') {
        this.props.handleSort(newState.sortField, newState.sortOrder);
      }
    }
  };

  render() {
    const { page, lemaData, count, formCount } = this.props;
    const rowStyle = { cursor: 'pointer' };
    return (
      <div className="m-2">
        <h6 className="text-muted">Rasta lemų: {count}, formų: {formCount}</h6>

        <BootstrapTable
          remote
          bootstrap4
          keyField='lema'
          data={lemaData}
          columns={mainColumns}
          expandRow={this.formsTable()}
          pagination={
            paginationFactory({ page, sizePerPage: 50, totalSize: count, hideSizePerPage: true })
          }
          onTableChange={this.onTableChange}
          hover
          classes="bg-light table-responsive"
          rowStyle={rowStyle}
          defaultSorted={defaultLemasSorted}
          noDataIndication={() => <div/>}
        />
      </div>
    );
  }
}

export default ResultsTable;

